import globals from "@homer.core/globals";
import scheduler from "@homer.core/scheduler";
import whenImages from "@homer.core/when.images";

scheduler.yield.low(whenImages).then(() => {
    globals.demand.request("@apfelkiste/errorhandler");
});
